import React, { useMemo, useState } from "react";
import { IonCheckbox } from "@ionic/react";
import { BooleanDataCheck } from "./PreferencesUtil";
export function Preferences_Checkbox({
  option,
  content,
  handleChange,
  isNone,
  preferenceList,
  ACCORD_TITLE
}: any) {
  const [renderKey,setRenderKey] = useState<any>(null);
  const handleCheck = (
    API_KEY: string,
    OPTION_VALUE: string
  ) => {
    let data: any = preferenceList.filter(
      (item: any) => item.key === API_KEY
    )[0];
    if (data && data.value) {
      setRenderKey(BooleanDataCheck(data.value[OPTION_VALUE]));
      return BooleanDataCheck(data.value[OPTION_VALUE]);
    }
  };
  return (
    <>
      {useMemo(
        () => (
          <IonCheckbox
            checked={handleCheck(
              content.API_KEY,
              option.OPTION_VALUE
            )}
            value={option.OPTION_VALUE}
            name={option.OPTION_VALUE}
            onIonChange={e =>
              handleChange(e, content.API_KEY, content.OPTION_TYPE,ACCORD_TITLE)
            }
            disabled={
              (content.API_KEY === "preferredtime" ||
                content.API_KEY === "preferreddaysofweek") &&
              isNone
                ? true
                : false
            }
            className="checkbox-desktop"
          />
        ),
        [renderKey,preferenceList]
      )}
    </>
  );
}
